import { ErrorHandler, Injectable } from '@angular/core';

// Gets loaded in production
declare var newrelic;

@Injectable({
  providedIn: 'root'
})
export class NewrelicErrorHandler extends ErrorHandler {
  get hasNewRelic(): boolean {
    return 'newrelic' in window;
  }

  constructor() {
    super();
  }

  handleError(error: any) {
    super.handleError(error);
    if (this.hasNewRelic) {
      newrelic.noticeError(error);
    }

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      if (
        confirm(
          'Sorry, an error occured while loading the page, contact support if the problem persists. Refresh the page?'
        )
      ) {
        window.location.reload();
      }
    }
  }
}
